// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.10-6UolF5LZuIaZoDlY8wmT/mode=imports,min/optimized/keen-slider.js'

class CardCarousel extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    if (window.BAO.MediaBreakpoints.isXsViewport && this.shouldMobileCarousel) {
      this.carousel = this.setupCarousel()
    } else if (window.BAO.MediaBreakpoints.isSm && this.shouldDesktopCarousel) {
      this.carousel = this.setupCarousel()
    }
  }

  setupCarousel () {
    this.onPreviousClick = this.onPreviousClick.bind(this)
    this.onNextClick = this.onNextClick.bind(this)
    this.onSlideChanged = this.onSlideChanged.bind(this)
    this.onSliderCreated = this.onSliderCreated.bind(this)

    this.classUp()

    const slider = new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      breakpoints: {
        [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
          slides: {
            perView: 3,
            spacing: 10,
          },
        },
        [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.md}px)`]: {
          slides: {
            perView: 3,
            spacing: 20,
          },
        },
      },
      slides: {
        perView: 2,
        spacing: 10,
      },
      slideChanged: this.onSlideChanged,
      created: this.onSliderCreated,
    })

    if (this.els?.previous?.element) {
      this.listeners.add(
        this.els.previous.element,
        'click',
        this.onPreviousClick,
      )
    }

    if (this.externalEls?.previous?.element) {
      this.listeners.add(
        this.externalEls.previous.element,
        'click',
        this.onPreviousClick,
      )
    }

    if (this.els?.next?.element) {
      this.listeners.add(this.els.next.element, 'click', this.onNextClick)
    }

    if (this.externalEls?.next?.element) {
      this.listeners.add(
        this.externalEls.next.element,
        'click',
        this.onNextClick,
      )
    }

    return slider
  }

  classUp () {
    if (!this.els.slides.element.classList.contains('keen-slider')) {
      this.els.slides.element.classList.add('keen-slider')
    }

    if (!this.els.slide.element.classList.contains('keen-slider__slide')) {
      this.els.slide.elements.forEach(el =>
        el.classList.add('keen-slider__slide'),
      )
    }
  }

  setCurrentPage () {
    if (!this.externalEls?.pages?.element) return

    this.externalEls.pages.element.textContent = `${this.currentPage}/${this.totalPages}`
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.abs
    this.currentPage = Math.ceil((currentSlide + 1) / this.perPage)

    this.previousDisabled = currentSlide === 0
    // TODO: Change this to be based on number of pages not slide count
    this.nextDisabled = currentSlide >= this.slideCount - this.perPage

    this.setCurrentPage()
  }

  onSliderCreated () {
    this.setAttribute('active', '')
    this.parent.setAttribute(`${this.localName}-active`, '')

    this.setCurrentPage()
  }

  onNextClick () {
    this.currentPage += 1

    const newIndex = (this.currentPage - 1) * this.perPage

    this.carousel.moveToIdx(
      newIndex > this.slideCount - this.perPage
        ? this.slideCount - this.perPage
        : newIndex,
      true,
    )
  }

  onPreviousClick () {
    this.currentPage -= 1

    this.carousel.moveToIdx((this.currentPage - 1) * this.perPage, true)
  }

  get previousDisabled () {
    return this._previousDisabled
  }

  set previousDisabled (val) {
    this._previousDisabled = val

    this.els.previous.element.disabled = val
    this.externalEls.previous.element.disabled = val
  }

  get nextDisabled () {
    return this._nextDisabled
  }

  set nextDisabled (val) {
    this._nextDisabled = val

    this.els.next.element.disabled = val
    this.externalEls.next.element.disabled = val
  }

  get currentPage () {
    return this._currentPage || 1
  }

  set currentPage (val) {
    if (val <= 0) {
      val = 1
    } else if (val > this.totalPages) {
      val = this.totalPages
    }

    this._currentPage = val
  }

  get perPage () {
    return window.BAO.MediaBreakpoints.isXsViewport ? 2 : 3
  }

  get totalPages () {
    return Math.ceil(this.slideCount / this.perPage)
  }

  get parentSelector () {
    return `[data-${this.identifier}-parent]`
  }

  get parent () {
    return this.closest(this.parentSelector)
  }

  get slideCount () {
    return this.els.slide.elements.length
  }

  get shouldMobileCarousel () {
    return this.slideCount > 2
  }

  get shouldDesktopCarousel () {
    return this.slideCount > 3
  }
}

if (!customElements.get('card-carousel')) {
  customElements.define('card-carousel', CardCarousel)
}
